module.exports = __webpack_public_path__ + "media/images/common/up_btn-37b13ef090017ea3ddd6c0dc0302780b.png";